import { useCallback } from "react";

import {
  PHASE2_SAVE_BANK_DETAILS,
  PHASE2_UPLOAD_DOCUMENT,
  phase2SubmitUrl,
} from "../../../../../../../config/Endpoints.js";
import { getAuthToken } from "../../../../../../../utils/Storage.js";
import { postEmptyBody, postFormDataMultipart } from "../../../../../../utils/api.ts";
import type { UsPostJoinDocumentType } from "../documents/us-document-types.ts";
import type { UsBankDetailsValues } from "../schemas/us-post-join.schema.ts";

function accessToken(): string | undefined {
  const token = getAuthToken("accessToken");
  return token != null && token !== "" ? token : undefined;
}

/** US payload adapter for the shared Phase 2 post-join endpoints. */
export function useUsPostJoinPhase2() {
  const saveBankDetails = useCallback(async (
    employeeId: number,
    values: UsBankDetailsValues,
    cancelledCheque: File,
  ) => {
    const formData = new FormData();
    formData.append("employeeId", String(employeeId));
    formData.append("beneficiaryName", values.beneficiaryName);
    formData.append("accountNumber", values.accountNumber);
    formData.append("bankName", values.bankName);
    formData.append("branchName", values.branchName);
    formData.append("routingNumber", values.routingNumber);
    formData.append("cancelledCheque", cancelledCheque);
    await postFormDataMultipart(PHASE2_SAVE_BANK_DETAILS, accessToken(), formData);
  }, []);

  const uploadDocument = useCallback(async (
    employeeId: number,
    docType: UsPostJoinDocumentType,
    file: File,
  ) => {
    const formData = new FormData();
    formData.append("employeeId", String(employeeId));
    formData.append("docType", docType);
    formData.append("file", file);
    await postFormDataMultipart(PHASE2_UPLOAD_DOCUMENT, accessToken(), formData);
  }, []);

  const submitPostJoin = useCallback(async (employeeId: number) => {
    await postEmptyBody(phase2SubmitUrl(employeeId), accessToken());
  }, []);

  return { saveBankDetails, uploadDocument, submitPostJoin };
}
